import React from "react";
import "./uni.css";
import { useNavigate } from "react-router-dom";

export default function Russia() {
  const Navigate = useNavigate()
  return (
    <div className="vbgy">
      <div className="dfhtu">
        <h2>MBBS in Uzbekistan</h2>
      </div>
      <div className="wityu">
        <img src="https://itcslimited.com/wp-content/uploads/2021/06/blog-oldest-medical-russia-banner.jpg"></img>

        <p>
          Studying MBBS in Uzbekistan currently turns into the ideal alternative
          for Indian students. It correlates with different medical
          examinations, experienced resources, looked after medical clinics, and
          phenomenal food quality. MBBS in Uzbekistan is a five years course and
          100% English medium all through the five years. Medical schooling in
          Uzbekistan is excellent; it satisfies the worldwide guideline of
          instruction. From the previous years, there has been a tremendous
          tendency of students for studying MBBS abroad. MBBS in Uzbekistan
          2022-23 is one of the commendable choices for Indian students to
          practice medicine abroad. Studying in medical colleges of Uzbekistan
          gives a more excellent calibre of training, regional pathology,
          learning diagnostics, taking care of the patients, practising medical
          care and some more.
          <br />
          <br />
          <button onClick={()=>{Navigate('/contact')}}>Apply Now</button>
        </p>
      </div>

      {/* 00000000000000000000000000000000000000000000000000000 */}

      <div className="nffd">
        <img src="https://www.7skyconsultancy.com/assets/images/Russia.png"></img>
        <div className="nhjip">
          <h3
            style={{
              backgroundColor: "#ff9818",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            A BRIEF LOOK AT MBBS IN UZBEKISTAN
          </h3>
          <br />
          <br />
          <table className="ewrfd">
            <tr>
              <td>Capital</td>
              <td>Tashkent</td>
            </tr>
            <tr>
              <td>Population</td>
              <td>3.42 crores(2020)</td>
            </tr>
            <tr>
              <td>Language</td>
              <td>Uzbek</td>
            </tr>
            <tr>
              <td>Medium of Instruction</td>
              <td>English</td>
            </tr>
            <tr>
              <td>Currency</td>
              <td>Uzbekistani Som(1 Som= 0.0073 INR)</td>
            </tr>
            <tr>
              <td>International Airport</td>
              <td>Tashkent</td>
            </tr>
            <tr>
              <td>Recognition</td>
              <td>NMC (MCI), WHO, ECFMG, FAIMER, WDOMS</td>
            </tr>
            <tr>
              <td>Course Duration</td>
              <td>6 Years(5 + 1 Year's internship)</td>
            </tr>
            <tr>
              <td>Average cost of stay (Fee included)</td>
              <td>15-20 lakhs(Approx)</td>
            </tr>
            <tr>
              <td>Intake(Fee included)</td>
              <td>Summer & Winter</td>
            </tr>
            <tr>
              <td>Accomodation Facilities(Fee included)</td>
              <td>Hostel & Apartment</td>
            </tr>
            <tr>
              <td>Indian Mess</td>
              <td>Available</td>
            </tr>
          </table>
        </div>
      </div>

      {/* 0000000000000000000000000000000000000000000000000000000000000000000000    */}
      <div className="cxdsf">
        <div className="ugvuids">
          <h2>UNIVERSITY OF UZBEKISTAN</h2>
          <table
            className="table"
            data-aos="zoom-in-up"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            <tr>
              <th className="th title2">UNIVERSITY NAME</th>
              <th className="th title2">TUTION FEE</th>
              <th className="th title2">HOSTAL FEE</th>
              <th className="th title2">OTC</th>
              <th className="th title2">TOTAL IN 1ST YEAR</th>
              <th className="th title2">INCENTIVE</th>
            </tr>
            {/* <!-- 1 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>1.</span>Andijan State Medical Institute
              </td>
              <td className="td">3600$</td>
              <td className="td">800$</td>
              <td className="td">2000$</td>
              <td className="td">6400$</td>
              <td className="td">1000$</td>
            </tr>
            {/* <!-- 2 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>2.</span>Bukhara State Medical Institute
              </td>
              <td className="td">5000$</td>
              <td className="td">500$</td>
              <td className="td">3000$</td>
              <td className="td">8500$</td>
              <td className="td">1000$</td>
            </tr>
            {/* <!-- 3 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>3.</span>Fergana State Medical University
              </td>
              <td className="td">3500$</td>
              <td className="td">600&</td>
              <td className="td">2000$</td>
              <td className="td">6100$</td>
              <td className="td">1000$ </td>
            </tr>

            {/* <!-- 4 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>4.</span>Samarkand State Medical Institute
              </td>
              <td className="td">3600$</td>
              <td className="td">400&</td>
              <td className="td">2500$</td>
              <td className="td">6500$</td>
              <td className="td">1000$ </td>
            </tr>

            {/* <!-- 5 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>5.</span>Tashkent Medical Academy
              </td>
              <td className="td">3000$</td>
              <td className="td">550&</td>
              <td className="td">4000$</td>
              <td className="td">7550$</td>
              <td className="td">1000$ </td>
            </tr>

            {/* <!-- 6 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>6.</span>Tashkent Medical Academy Urgench
              </td>
              <td className="td">3500$</td>
              <td className="td">550&</td>
              <td className="td">2000$</td>
              <td className="td">6050$</td>
              <td className="td">1200$</td>
            </tr>
          </table>
        </div>
      </div>
      <section className="ugvui">
        <ul>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Above Mentioned Tution Fee Chargable According to Their Academic
            Session.
          </li>

          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Admission Fee, Documentation & VISA Processing will be 30 to 35,000,
            depands on telex no.
          </li>

          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Form 2nd to 6th year's Police Registration, Medical lnsc. & VISA
            Extension will be Extra(400$ to 500$).
          </li>

          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Flight Ticket Charge Excluded.
          </li>

          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Indian Mess Food 120$ Per Month Extra.
          </li>

          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            <span>
              <b>Note:</b>
            </span>
            <br />
            In certain case students have to pay either partial or full amount
            of tuition fee to the university soon after receive letter, as per
            the University instruction.
          </li>
        </ul>
      </section>

      {/* 0000000000000000000000000000000000000000000000000000000000000000000000 */}

      <div className="gsfas">
        <h3>TASHKENT MEDICAL ACADEMY</h3>

        <div className="sdgdfghf">
          <img src="https://www.metaeducationindia.com/wp-content/uploads/2021/02/Bashkir-state-medical-university.jpg"></img>

          <p>
            Established in 2005, Tashkent Medical Academy traces back its
            history to 1920, making it one of the oldest medical universities in
            Uzbekistan to study MBBS. Before forming Tashkent Medical Academy in
            2005 it used to be known as Tahkent state university and Tashkent
            medical institute in 1931 and 1990 respectively. Also the University
            has 3 branches at the moment : Urgench Branch, Fergana Branch and
            Termez Branch respectively.
            <br />
            <strong>ESTO. : 2005</strong>
            <br />
            <strong>University Type : Private</strong>
            <br />
            <strong>Medium : English</strong>
            <br />
            <strong>ESTO. : No. of Indian Students : 500+</strong>
            <br />
          </p>
        </div>
      </div>

      {/* 0000000000000000000000000000000000000000000000000 */}

      <div className="packageForFirstYear">
        <table className="table fgjhfghfg" border="1">
          <h2 style={{ textAlign: "center", width: "100%" }}>
            PACKAGE FOR 1ST YEAR STUDENT
          </h2>
          <thead>
            <tr>
              <td className="td">TUITION FEE</td>
              <td className="td">HOSTEL FEE</td>
              <td className="td td2">
                IMMIGRATION CLERANCE,AIRPORT PICKUP, ARRIVAL MEAL, TRANSLATION
                AND ATTESTATION OF DOCUMENTS IN UNIVERSITY, MEDICAL INSURANCE &
                MEDICAL CHECKUP, LOCAL POLICE VERIFICATION, BIOMETRIC AND VISA
                EXTENTION, HOSTEL ALLOTMENT, BANK ACCOUNT OPENING, LOCAL SUPPORT
                ETC
              </td>
              <td className="td">TOTAL FEE</td>
              <td className="td">INCENTIVE</td>
            </tr>
            {/* <!-- 2 --> */}
            <tr>
              <td className="td">3000$</td>
              <td className="td">550$</td>
              <td className="td">4000$</td>
              <td className="td">7550$</td>
              <td className="td">1000$</td>
            </tr>
          </thead>
        </table>
        <p className="para border">FOOD FEE PER MONTH - 120$ (COMPULSORY)</p>
        <p className="para border pb0">
          ADMISSION FEE, VISA PROCESSING & DOCUMENTATION ( 30-35000) I FLIGHT
          TICKET AS PER ACTUAL.
        </p>
      </div>

      {/* 000000000000000000000000000000000000000000000000000000000000000 */}

      <div
        className="packageForSixYear"
        data-aos="zoom-out"
        data-aos-duration="1000"
        data-aos-easing="linear"
      >
        <h3 className="packagewhite">PACKAGE FOR 2ND TO 6TH YEAR STUDENT</h3>
        <table className="table">
          <tbody>
            <tr>
              <th className="th title2">Package</th>
              <th className="th title2">2nd</th>
              <th className="th title2">3rd</th>
              <th className="th title2">4th</th>
              <th className="th title2">5th</th>
              <th className="th title2">6th</th>
            </tr>
            {/* <!-- 1 --> */}
            <tr>
              <td className="td ">Tuition Fee</td>
              <td className="td">3000$</td>
              <td className="td">3000$</td>
              <td className="td">3000$</td>
              <td className="td">3000$</td>
              <td className="td">3000$</td>
            </tr>
            {/* <!-- 2 --> */}
            <tr>
              <td className="td">Hostel Fee</td>
              <td className="td">550$</td>
              <td className="td">550$</td>
              <td className="td">550$</td>
              <td className="td">550$</td>
              <td className="td">550$</td>
            </tr>
            {/* <!-- 3 --> */}
            <tr>
              <td className="td">
                Police Registration Medical Insurance VISA Extention
              </td>
              <td className="td">600$-800$</td>
              <td className="td">600$-800$</td>
              <td className="td">600$-800$</td>
              <td className="td">600$-800$</td>
              <td className="td">600$-800$</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mainSec">
        <ul>
          <li className="para">
            <span>
              {" "}
              IMPORTANT NOTE <b>:</b>
            </span>
            <br />
            <br />
            <p
              data-aos="zoom-out"
              data-aos-duration="1000"
              data-aos-easing="linear"
            >
              The institute offers world-class education at affordable tuition
              fees.
            </p>
            <br />
            <p
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-easing="linear"
            >
              The institute accounts for regional factors like religious
              freedom, law defense which are critically important for Asian and
              Latin American countries.
            </p>{" "}
            <br />
            <p
              data-aos="zoom-out"
              data-aos-duration="1000"
              data-aos-easing="linear"
            >
              With well-equipped classrooms, basic science and clinical
              laboratories, training centers and clinical bases impart
              world-class education to young minds.
            </p>{" "}
            <br />
            <p
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-easing="linear"
            >
              The university has cooperation with international scientific and
              educational centers that provide knowledge and exposure to
              students
            </p>{" "}
            <br />
            <p
              data-aos="zoom-out"
              data-aos-duration="1000"
              data-aos-easing="linear"
            >
              The experienced staff at the university always strives to
              implement advanced teaching methodology that enhances clinical and
              interpersonal skills of the students
            </p>{" "}
            <br />
          </li>
        </ul>
      </div>
    </div>
  );
}
